import { createAction } from '@reduxjs/toolkit';

import type { SavedAddress } from './addresses.types';

const getAll = {
  pending: createAction('addresses/getAll/pending'),
  fulfilled: createAction<SavedAddress[]>('addresses/getAll/fulfilled'),
  rejected: createAction('addresses/getAll/rejected'),
};

export default { getAll };
